import { baseApi } from "./baseApi";

const NOTIFICATION_BASE_URL = "/notification";

export const notificationApi = baseApi.injectEndpoints({
  tagTypes: ["Notification"],

  endpoints: (builder) => ({
    getNotificationList: builder.query({
      query: (params) => ({ url: `${NOTIFICATION_BASE_URL}`, params }),
      providesTags: (result) =>
        result
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "Notification",
              _id,
            })),
            { type: "Notification", id: "LIST" },
          ]
          : [{ type: "Notification", id: "LIST" }],
    }),

    onNotificationRead: builder.mutation({
      query: (id) => ({
        url: `${NOTIFICATION_BASE_URL}/${id}`,
        method: "PUT",
      }),
    }),

    notificationReadAll: builder.mutation({
      query: () => ({
        url: `${NOTIFICATION_BASE_URL}`,
        method: "PUT",
      }),
      invalidatesTags: (result, error) => [
        { type: "Notification", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetNotificationListQuery,
  useLazyGetNotificationListQuery,

  useOnNotificationReadMutation,

  useNotificationReadAllMutation,
} = notificationApi;
